import { PORTAL_UI_V2 } from "../config/uiTheme";
import SiteListLegacy from "./sites/SiteListLegacy";
import SiteListV2 from "./sites/SiteListV2";

const SiteList = () => (PORTAL_UI_V2 ? <SiteListV2 /> : <SiteListLegacy />);

export default SiteList;
